import React from 'react';

import useConfirm from '../Modal/ConfirmModal/useConfirm';

const useDiscardChanges = (): [React.FC, () => Promise<boolean>] => {
  const [DiscardChangesModal, confirmDiscard] = useConfirm({
    classes: '',
    title: 'Discard Changes',
    message: `Do you wish to proceed?`,
    confirmBtn: {
      label: 'Discard',
    },
  });

  return [DiscardChangesModal, confirmDiscard];
};

export default useDiscardChanges;
